import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from './icon';
import { mq } from './_shared/media';
import { StyledH1 } from './_shared/styled-headings';
import { StyledSection } from './_shared/styled-section';
import TextLink from './links/text-link';
import { flexCenter } from './_shared/styled-mixins';
import { flexEnd } from './_shared/styled-mixins';
import './cardGrid.css';

import withAutoplay from 'react-awesome-slider/dist/autoplay';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

const StyledTextSection = styled.section`
  white-space: pre-line;
`;
const StyledFeatureGridContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 0.5rem;
  margin-top: 0.5rem;
  width: 100%;

  ${mq.gt.xs} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${mq.gt.sm} {
    grid-template-columns: repeat(2, 1fr);
  }
`;
const StyledArchiveContainer = styled.div`
  ${flexCenter};
  width: 100%;
  margin-top: 2.5rem;
`;

const StyledFeatureCard = styled.article`
  ${'' /* border: 1px solid var(--body-color); */}
  border-radius: var(--radius);
  background-color: #1b1d2a;
  display: flex;
  ${'' /* align-items: center; */}
  text-align: left;
  flex-direction: column;
  min-height: 250px;
  padding: 1.2rem;
  justify-content: space-between;

  & svg {
    height: 2rem;
    width: 2rem;
    font-size: 2rem;
  }
`;
const StyledCardLabel = styled.h2`
  font-size: 1.13rem;
  margin: 0;
  color: var(--body-color);
`;
const StyledDivider = styled.div`
  width: 15%;
  height: 2px;
  background-color: var(--primary-color);
  margin-bottom: 1rem;
`;
const StyledFeatureDescription = styled.p`
  font-size: 0.8rem;
  text-align: justify;
  text-justify: inter-word;
`;

const StyledIcon = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;

const StyledLinkContainer = styled.section`
  ${flexEnd};
  margin: 10px 0;

  & > a {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: '1px';
    color: var(--body-color);

    &:hover {
      color: var(--primary-color);
    }
  }

  & svg {
    margin: 0 0.5rem;
  }
`;

const AutoplaySlider = withAutoplay(AwesomeSlider);

const CardGrid = ({ cards, description, title, id = null }) => {
  const featureCards = cards.map(
    ({ icon, prefix, label, description, images, skills, repo_link, demo_link }, index) => {
      console.log(images, skills);
      return (
        <div key={index} className="container">
          <div className={'imageCarousel'}>
            <AutoplaySlider
              play={true}
              cancelOnInteraction={true} // should stop playing on user interaction
              interval={2000}
              bullets={false}
              infinite={false}
              className="car-contain"
            >
              {images.map(({ childImageSharp }) => {
                const {
                  fluid: { src = '' },
                } = childImageSharp;
                console.log(src);
                return (
                  <div
                    key={src}
                    style={{
                      backgroundImage: `url(${src})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                  />
                );
              })}
            </AutoplaySlider>
          </div>
          <div className="content">
            <div className="labelSection">
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <Icon icon={icon} prefix={prefix} />
                <StyledCardLabel>{label}</StyledCardLabel>
              </div>
              <StyledLinkContainer className="icons">
                {repo_link && (
                  <a href={repo_link} target="_blank" rel="noopener" title="Repository Link" aria-label={'gitHub Link'}>
                    <Icon icon="github" prefix="fab" />
                  </a>
                )}
                {demo_link && (
                  <a href={demo_link} target="_blank" rel="noopener" title="Repository Link" aria-label={'Demo Link'}>
                    <Icon icon="external-link-alt" />
                  </a>
                )}
              </StyledLinkContainer>
            </div>
            <StyledDivider></StyledDivider>
            <div className="description">{description}</div>
            <div className="skills">
              <h5>skills:- </h5>
              <span>
                {skills.map((skill, index) => {
                  const punctuation = index === skills.length - 1 ? '.' : ',';
                  return <span key={skill}>{`${skill}${punctuation} `}</span>;
                })}
              </span>
            </div>
          </div>
        </div>
      );
    }
  );

  return (
    <>
      <StyledSection id={id}>
        {title && <StyledH1>{title}</StyledH1>}
        <StyledTextSection dangerouslySetInnerHTML={{ __html: description }} />
        <StyledFeatureGridContainer>{featureCards}</StyledFeatureGridContainer>

        {/* <StyledArchiveContainer>
          <TextLink label="View All Projects" link="/projects" />
        </StyledArchiveContainer> */}
      </StyledSection>
    </>
  );
};

CardGrid.propTypes = {
  cards: PropTypes.array.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.string,
  title: PropTypes.string,
};

export default CardGrid;

{
  /* <StyledFeatureCard key={index}>
        <Icon icon={icon} prefix={prefix} />
        <StyledCardLabel>{label}</StyledCardLabel>
        <StyledDivider></StyledDivider>
        <StyledFeatureDescription>{description}</StyledFeatureDescription>
        <StyledLinkContainer>
          {repo_link && (
            <a href={repo_link} target="_blank" rel="noopener" title="Repository Link" aria-label={'gitHub Link'}>
              <Icon icon="github" prefix="fab" />
            </a>
          )}
          {demo_link && (
            <a href={demo_link} target="_blank" rel="noopener" title="Repository Link" aria-label={'Demo Link'}>
              <Icon icon="external-link-alt" />
            </a>
          )}
        </StyledLinkContainer>
      </StyledFeatureCard> */
}
